import GrowthDiscoveryExperiments from 'bundles/epic/clients/GrowthDiscovery';

export const getTempBadgeStylesLihpCdsProductCards = () =>
  GrowthDiscoveryExperiments.preview('newBadgeStylesOnLihpProductCards');
export const getTempBadgeStylesLihpCdsProductCardsWithImpression = () =>
  GrowthDiscoveryExperiments.get('newBadgeStylesOnLihpProductCards');
